<!-- src/views/Profile.vue -->
<template>
    <div>
      <h1>Profile Page</h1>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Profile'
    
  }
  </script>
  
  <style scoped>
  /* Add styles here */
  </style>